package com.ijoin.data.model

import kotlinx.serialization.Serializable

@Serializable
enum class PayoutMode {
    PLATFORM_MERCHANT,
    DIRECT_CONNECT
}

@Serializable
data class ConnectAccountStatus(
    val payoutMode: String,
    val stripeConnectAccountId: String? = null,
    val chargesEnabled: Boolean? = null,
    val detailsSubmitted: Boolean? = null,
    val payoutsEnabled: Boolean? = null,
    val platformFeePercent: Double? = null,
    val dashboardLoginUrl: String? = null,
    val statusMessage: String? = null,
    val canEnableDirectPayments: Boolean? = null
) {
    val isDirectMode: Boolean
        get() = payoutMode == PayoutMode.DIRECT_CONNECT.name

    val isPlatformMode: Boolean
        get() = payoutMode == PayoutMode.PLATFORM_MERCHANT.name

    val hasConnectAccount: Boolean
        get() = !stripeConnectAccountId.isNullOrBlank()

    val isOnboardingComplete: Boolean
        get() = detailsSubmitted == true && chargesEnabled == true

    val isUnderReview: Boolean
        get() = detailsSubmitted == true && chargesEnabled != true

    val needsOnboarding: Boolean
        get() = !hasConnectAccount || detailsSubmitted != true
}

@Serializable
data class ConnectOnboardingLinkResponse(
    val url: String,
    val dashboardUrl: String? = null
)

@Serializable
data class ConnectDashboardLinkResponse(
    val url: String
)

@Serializable
data class SwitchPayoutModeRequest(
    val targetMode: String
)

@Serializable
data class OnboardingRequest(
    val refreshUrl: String,
    val returnUrl: String
)
